import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './InvoiceEditPaymentInstallmentsHeader.module.scss';

type InvoiceEditPaymentInstallmentsHeaderProps = {
	somePaymentInstallmentsMutable: boolean;
	isMobile?: boolean;
	amountLabel: string;
};

export const InvoiceEditPaymentInstallmentsHeader: React.FC<
InvoiceEditPaymentInstallmentsHeaderProps
> = ( { isMobile, somePaymentInstallmentsMutable, amountLabel } ) =>
	isMobile ? null : (
		<Box
			className={ [ styles.headerContainer, !somePaymentInstallmentsMutable ? styles.immutable : undefined, ].join( ' ' ) }
			data-cy='invoice-edit-payment-installments-header'
		>
			<Typography
				component='div'
				data-cy='invoice-edit-payment-installment-name-header'
			>
				Name
			</Typography>
			<Typography
				component='div'
				data-cy='invoice-edit-payment-installment-dueDate-header'
			>
				Due date
			</Typography>
			<span></span>
			<Typography
				component='div'
				data-cy='invoice-edit-payment-installment-amountDue-header'
			>
				{ amountLabel }
			</Typography>
			<Typography
				component='div'
				data-cy='invoice-edit-payment-installment-percentage-header'
			>
				Percentage
			</Typography>
			{ somePaymentInstallmentsMutable ? <span></span> : null }
		</Box>
	);
